import { FC } from 'react';

import CsvFormat from 'components/ImportCsv/StepsComponents/UploadCsvStep/CsvFormat';
import CsvUpload from 'components/ImportCsv/StepsComponents/UploadCsvStep/CsvUpload';

const UploadCsvStep: FC<any> = ({ setFileColumns }) =>
  <>
    <p className="m-b-10">This tool allows you to import (or merge) product data to your store from a CSV file.</p>
    <div className="d-f gap-20">
      <CsvUpload setFileColumns={setFileColumns} />
      <CsvFormat />
    </div>
  </>;

export default UploadCsvStep;
